module.exports = __webpack_public_path__ + "static/media/energy.8f72d30d.png";